import { AuthBase } from "./AuthBase";
/**
 * Node.js-specific implementation of authentication service
 */
export class AuthNode extends AuthBase {
    username;
    password;
    /**
     * Create a new Node.js authentication service
     *
     * @param config - Configuration options
     * @param fetchImpl - The fetch implementation to use
     */
    constructor(config, fetchImpl) {
        super(config, fetchImpl);
        this.username = config.username;
        this.password = config.password;
    }
    /**
     * Get the access token
     * @returns Promise with the access token
     */
    async getAccessToken() {
        const now = Date.now();
        // Return cached token if it's still valid
        if (this.cachedToken && this.tokenExpiry > now) {
            return this.cachedToken;
        }
        // Get a new token
        const response = await this.authenticate(this.username, this.password);
        if (response && response.access_token) {
            this.cachedToken = response.access_token;
            // Set expiry time (subtract a buffer to ensure we refresh before actual expiry)
            this.tokenExpiry = now + response.expires_in * 1000 - 60000;
            return this.cachedToken;
        }
        return null;
    }
    /**
     * Get the raw token
     * @returns The raw token
     */
    getRawToken() {
        return this.cachedToken;
    }
    /**
     * Perform auto sign-in
     * @returns Promise that resolves when auto sign-in is complete
     */
    async autoSignIn() {
        return (await this.getAccessToken()) !== null;
    }
}
